export const returnButtonSx = {
  position: 'absolute',
  backgroundColor: 'rgb(101 101 101)',
};

export const root = '/';